const e = /* @__PURE__ */ new Set([
  "err",
  "error",
  "req",
  "res",
  "responseTime",
  "level",
  "msg",
  "message",
  "time",
  "context",
  "service",
  "env",
  "pid",
  "hostname"
]), o = [
  "apiKey",
  "apiSecret",
  "password",
  "secret",
  "token",
  "accessToken",
  "refreshToken",
  "authorization",
  "cookie",
  "x-api-key",
  "*.apiKey",
  "*.apiSecret",
  "*.password",
  "*.secret",
  "*.token",
  "*.accessToken",
  "*.refreshToken",
  "*.authorization",
  "*.cookie",
  "headers.authorization",
  "headers.cookie",
  'headers["x-api-key"]',
  "req.headers.authorization",
  "req.headers.cookie",
  'req.headers["x-api-key"]',
  'res.headers["set-cookie"]'
], r = /* @__PURE__ */ new Set([
  "apikey",
  "apisecret",
  "password",
  "secret",
  "token",
  "accesstoken",
  "refreshtoken",
  "authorization",
  "cookie"
]), s = "[REDACTED]", a = 4;
export {
  a as MAX_REDACT_DEPTH,
  s as REDACTED,
  o as REDACT_PATHS,
  r as SENSITIVE_KEYS,
  e as SENTRY_EXTRAS_EXCLUDE
};
